import { render } from "./App.vue?vue&type=template&id=a4c4893a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a4c4893a&lang=css"

import exportComponent from "D:\\Mindscan\\online-quiz-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__